import './scss/main.scss'

import { createApp } from 'vue'
import App from './App.vue'
import i18n from './i18n'
import { createVuestic } from 'vuestic-ui'
import { createGtm } from '@gtm-support/vue-gtm'
import router from './router'
import stores from './stores'
import vuesticGlobalConfig from './services/vuestic-ui/global-config'
import { ApiService } from './services/api.service';
import JwtService from './services/jwt.service'

const app = createApp(App)

ApiService.init();
if (JwtService.hasToken()) {
  ApiService.setHeader();
}

// Make router globally accessible
app.config.globalProperties.$router = router

app.use(stores)
app.use(router) 
app.use(i18n)
app.use(createVuestic({ config: vuesticGlobalConfig }))

if (import.meta.env.VITE_APP_GTM_ENABLED) {
  app.use(
    createGtm({
      id: import.meta.env.VITE_APP_GTM_KEY,
      debug: false,
      vueRouter: router,
    }),
  )
}

app.mount('#app')